import React from "react";
import * as Icon from "react-feather";
import Modal from "react-responsive-modal";
import AFSService from "../../../../../services/AFSService";
import WComponent from "../../../../common/WComponent";
import ToolsDocumentPane from "../../kit/ToolsDocumentPane";
import "./document-viewer-modal.css";

/**
 * Inline document viewer.
 *
 * A modal shell around ToolsDocumentPane, which is the one place a source
 * document is drawn and the one place that knows what to show when it cannot
 * be. This decides which id the pane is being asked for and names it.
 *
 * Props:
 *   open               — controls visibility
 *   onClose            — called when the user dismisses
 *   doc                — { id?, name, doc_type, source? } — the document
 *                        descriptor used elsewhere in the app. We resolve to
 *                        evidenceItemId / documentId based on `source`.
 *   evidenceItemId     — explicit override (preferred when source === "evidence_item")
 *   documentId         — explicit override (preferred when source === "document")
 */
class DocumentViewerModal extends WComponent {
	render() {
		let { open, onClose, doc, evidenceItemId, documentId } = this.props;

		let resolvedEvId = evidenceItemId;
		let resolvedDocId = documentId;
		if (resolvedEvId == null && resolvedDocId == null && doc) {
			if (doc.source === "document") resolvedDocId = doc.id;
			else resolvedEvId = doc.id; // default — agent-mode docs are usually evidence items
		}

		let url = (resolvedEvId != null || resolvedDocId != null)
			? AFSService.getDocumentViewUrl({ evidenceItemId: resolvedEvId, documentId: resolvedDocId })
			: null;

		let title = (doc && (doc.name || doc.doc_type)) || "Document";

		return (
			<Modal
				open={open}
				center
				onClose={onClose}
				showCloseIcon={false}
				classNames={{ modal: "document-viewer-modal", modalContainer: "document-viewer-modal-container" }}
				styles={{ modal: { width: "85vw", maxWidth: 1100, height: "90vh", padding: 0, display: "flex", flexDirection: "column", borderRadius: 6, overflow: "hidden" } }}
			>
				<div className="document-viewer-modal__header">
					<Icon.FileText size={16} color="#395395" className="document-viewer-modal__header-icon" />
					<span className="document-viewer-modal__title">{title}</span>
					{url && (
						<a
							href={url}
							target="_blank"
							rel="noopener noreferrer"
							title="Open in a new tab"
							className="document-viewer-modal__open-link"
						>
							<Icon.ExternalLink size={11} />
							<span>Open in new tab</span>
						</a>
					)}
					<button
						type="button"
						onClick={onClose}
						title="Close"
						aria-label="Close"
						className="document-viewer-modal__close-btn"
					>
						<Icon.X size={14} />
					</button>
				</div>
				<div className="document-viewer-modal__body">
					<ToolsDocumentPane
						documentId={resolvedDocId}
						evidenceItemId={resolvedEvId}
						title={title}
						nothingOnFileMessage="No source available for this document."
					/>
				</div>
			</Modal>
		);
	}
}

export default DocumentViewerModal;
